export function defaultOptionsValues() {
  return {
    showLegend: false,
  };
}
